import React from 'react';
import { Link } from 'react-router-dom';
import aboutBgImage from '../../assets/myImage/ehsan2.jpeg';

const About = () => {
    return (
        <section id='about' className='mt-28'>
            <div className='md:grid md:grid-cols-2 flex flex-col'>
                <div className='md:my-0 my-10 md:mx-0 mx-3' data-aos="fade-down" data-aos-duration="3000">
                    <img src={aboutBgImage} alt="aboutBGImage" className='w-[90%] h-[100%] shadow-lg' />
                </div>
                <div className='flex justify-center items-center md:mx-0 mx-5' data-aos="fade-down" data-aos-duration="3000">
                    <div>
                        <h1 className='text-5xl font-bold' style={{ color: '#65647C' }}>About Me</h1>
                        <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-2 mb-5"></hr>
                        <p>I am Md. Ehsanul Islam Khan. I have done my graduation B.Sc (Engg.) from Computer Science and Engineering (CSE) at the University of Science and Technology Chittagong (USTC). Currently I'm working as an Assistant Engineer in IT department at YOUNGONE Corporation, CEPZ. Here I design and configure network switche, router and also monitor the network. Besides, I diagnose and troubleshoot computer hardware problems.
                            <br /><br />
                            I love to learn new technologies. As a tech lover I try to put my learning into reality. I am a quick learner, highly passionate, hardworking person and have the ability to work under pressure. I have a passion on technology field and that's the reason I love to work on here. I want to see my self as a successful IT professional person in near future where I can implement my engineering skills.</p>
                        <Link to='/about' type='button' className="text-white bg-gradient-to-br from-cyan-500 to-blue-700 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 mt-8">
                            See More Details
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;